import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: '', message: '' });

    try {
      // Use relative URL for production, falls back to localhost for development
      const apiUrl = process.env.NODE_ENV === 'production' 
        ? '/api/contact' 
        : 'http://localhost:5000/api/contact';
      
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setSubmitStatus({ 
          type: 'success', 
          message: data.message || 'Thank you for your message! We will get back to you soon.' 
        });
        setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
      } else {
        setSubmitStatus({ 
          type: 'error', 
          message: data.message || 'Failed to send message. Please try again.' 
        });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus({ 
        type: 'error', 
        message: 'Failed to send message. Please try again later or contact us directly at sales@switchboard.uk' 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header />
      
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section with Background Image */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dkt3.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Animated Pattern Overlay */}
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          
          {/* Gradient Border Bottom */}
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '5px',
            background: 'linear-gradient(90deg, #B17ACC 0%, #7B3F9E 50%, #B17ACC 100%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 3s ease-in-out infinite'
          }}></div>
          
          <div className="container" style={{ position: 'relative', zIndex: 2, padding: '80px 20px' }}>
            <div className="row justify-content-center text-center">
              <div className="col-lg-8">
                {/* Animated Badge */}
                <div style={{
                  display: 'inline-block',
                  backgroundColor: 'rgba(123, 63, 158, 0.2)',
                  backdropFilter: 'blur(10px)',
                  padding: '12px 30px',
                  borderRadius: '50px',
                  marginBottom: '30px',
                  border: '2px solid rgba(123, 63, 158, 0.4)',
                  boxShadow: '0 4px 20px rgba(123, 63, 158, 0.2)'
                }}>
                  <span style={{ 
                    color: '#e0d9e4ff', 
                    fontSize: '0.9rem', 
                    fontWeight: '700', 
                    letterSpacing: '2px',
                    textShadow: '0 0 10px rgba(123, 63, 158, 0.5)'
                  }}>
                    📧 CONTACT US
                  </span>
                </div>
                
                <div style={{
                  marginBottom: '25px'
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    backgroundColor: 'rgba(255,255,255,0.95)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto',
                    boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
                    fontSize: '2.5rem'
                  }}>
                    📧
                  </div>
                </div>
                
                <h1 style={{ 
                  fontSize: '4.5rem', 
                  fontWeight: '800',
                  color: 'white',
                  marginBottom: '30px',
                  lineHeight: '1.1',
                  letterSpacing: '-2px',
                  textShadow: '0 4px 30px rgba(0,0,0,0.5), 0 0 60px rgba(123, 63, 158, 0.2)'
                }}>
                  Get in Touch
                </h1>
                
                {/* Decorative Line */}
                <div style={{
                  width: '150px',
                  height: '6px',
                  background: 'linear-gradient(90deg, transparent, #B17ACC, transparent)',
                  margin: '0 auto 35px',
                  borderRadius: '10px',
                  boxShadow: '0 0 20px rgba(123, 63, 158, 0.5)'
                }}></div>
                
                <p style={{
                  fontSize: '1.4rem',
                  color: 'rgba(255,255,255,0.95)',
                  maxWidth: '700px',
                  margin: '0 auto',
                  lineHeight: '1.8',
                  textShadow: '0 2px 15px rgba(0,0,0,0.3)',
                  fontWeight: '300'
                }}>
                  We're here to answer any questions you may have
                </p>
              </div>
            </div>
          </div>
          
          <style>{`
            @keyframes float {
              0%, 100% { transform: translateY(0px); }
              50% { transform: translateY(-20px); }
            }
            @keyframes shimmer {
              0% { background-position: 200% 0; }
              100% { background-position: -200% 0; }
            }
          `}</style>
        </section>

        <section id="contact" className="contact section" style={{ padding: '80px 0' }}>
          <div className="container" data-aos="fade-up">
            {/* Map */}
            <div className="row mb-5">
              <div className="col-lg-12">
                <div className="shadow-lg" style={{ 
                  height: '450px', 
                  borderRadius: '24px', 
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }} data-aos="fade-up" data-aos-delay="100">
                  <iframe 
                    src="https://www.google.com/maps?q=3+Vicarage+Ln,+London+E15+4HF,+United+Kingdom&output=embed" 
                    width="100%" 
                    height="100%" 
                    style={{ border: 0 }} 
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                    title="DTK College Location"
                  ></iframe>
                </div>
              </div>
            </div>

            {/* Contact Info and Form */}
            <div className="row gy-4 mb-5">
              {/* Our Address */}
              <div className="col-lg-5" data-aos="fade-up" data-aos-delay="150">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  height: '100%',
                  border: '1px solid #e2e8f0'
                }}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    backgroundColor: '#F5EBFA',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '25px',
                    border: '3px solid #B17ACC'
                  }}>
                    <i className="bi bi-geo-alt-fill" style={{ fontSize: '1.8rem', color: '#B17ACC' }}></i>
                  </div>
                  
                  <h2 className="mb-4" style={{ 
                    color: '#1e293b', 
                    fontSize: '1.8rem',
                    fontWeight: '700',
                    letterSpacing: '-0.5px'
                  }}>
                    Our Address
                  </h2>
                  
                  <div className="mb-4">
                    <div className="mb-4 pb-4" style={{ borderBottom: '1px solid #e2e8f0' }}>
                      <div className="d-flex align-items-start">
                        <div style={{
                          width: '40px',
                          height: '40px',
                          backgroundColor: '#F5EBFA',
                          borderRadius: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '15px',
                          flexShrink: 0
                        }}>
                          <i className="bi bi-geo-alt-fill" style={{ fontSize: '1.2rem', color: '#B17ACC' }}></i>
                        </div>
                        <div>
                          <p style={{ color: '#1e293b', marginBottom: '0', fontSize: '1.05rem', lineHeight: '1.7' }}>
                            3 Vicarage Ln, London E15 4HF, United Kingdom
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="mb-4 pb-4" style={{ borderBottom: '1px solid #e2e8f0' }}>
                      <div className="d-flex align-items-start">
                        <div style={{
                          width: '40px',
                          height: '40px',
                          backgroundColor: '#F5EBFA',
                          borderRadius: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '15px',
                          flexShrink: 0
                        }}>
                          <i className="bi bi-envelope-fill" style={{ fontSize: '1.2rem', color: '#B17ACC' }}></i>
                        </div>
                        <div>
                          <p style={{ color: '#1e293b', marginBottom: '0', fontSize: '1.05rem' }}>
                            admin@dtkcollege.co.uk
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="mb-4 pb-4" style={{ borderBottom: '1px solid #e2e8f0' }}>
                      <div className="d-flex align-items-start">
                        <div style={{
                          width: '40px',
                          height: '40px',
                          backgroundColor: '#F5EBFA',
                          borderRadius: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '15px',
                          flexShrink: 0
                        }}>
                          <i className="bi bi-telephone-fill" style={{ fontSize: '1.2rem', color: '#B17ACC' }}></i>
                        </div>
                        <div>
                          <p style={{ color: '#1e293b', marginBottom: '5px', fontSize: '1.05rem' }}>
                            +44(0)208 536 1311
                          </p>
                          <p style={{ color: '#1e293b', marginBottom: '0', fontSize: '1.05rem' }}>
                            +44(0)208 555 4999
                          </p>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className="d-flex align-items-start">
                        <div style={{
                          width: '40px',
                          height: '40px',
                          backgroundColor: '#F5EBFA',
                          borderRadius: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '15px',
                          flexShrink: 0
                        }}>
                          <i className="bi bi-clock-fill" style={{ fontSize: '1.2rem', color: '#B17ACC' }}></i>
                        </div>
                        <div>
                          <p style={{ color: '#1e293b', marginBottom: '8px', fontSize: '1.05rem' }}>
                            <strong>Mon - Thurs:</strong> 9:30 AM TO 6:00 PM
                          </p>
                          <p style={{ color: '#1e293b', marginBottom: '8px', fontSize: '1.05rem' }}>
                            <strong>Fri:</strong> 9:30 AM TO 4:00 PM
                          </p>
                          <p style={{ color: '#1e293b', marginBottom: '0', fontSize: '1.05rem' }}>
                            <strong>Sat - Sun:</strong> Closed
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Business Development Team */}
                    <div className="mt-4 p-4" style={{
                      backgroundColor: '#F5EBFA',
                      borderRadius: '16px',
                      border: '2px solid #B17ACC',
                      boxShadow: '0 4px 15px rgba(123, 63, 158, 0.15)'
                    }}>
                      <div className="d-flex align-items-start">
                        <div style={{
                          width: '50px',
                          height: '50px',
                          backgroundColor: '#B17ACC',
                          borderRadius: '12px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '15px',
                          flexShrink: 0,
                          boxShadow: '0 4px 12px rgba(123, 63, 158, 0.3)'
                        }}>
                          <i className="bi bi-briefcase-fill" style={{ fontSize: '1.5rem', color: 'white' }}></i>
                        </div>
                        <div>
                          <h4 style={{ 
                            color: '#7B3F9E', 
                            marginBottom: '12px', 
                            fontSize: '1.3rem',
                            fontWeight: '700'
                          }}>
                            Business Development Team
                          </h4>
                          <p style={{ 
                            color: '#475569', 
                            marginBottom: '10px', 
                            fontSize: '1rem',
                            lineHeight: '1.7'
                          }}>
                            We would welcome the opportunity to speak to you to learn more about your organisation 
                            and what we can do for you.
                          </p>
                          <p style={{ 
                            color: '#475569', 
                            marginBottom: '0', 
                            fontSize: '1rem',
                            lineHeight: '1.7',
                            fontWeight: '500'
                          }}>
                            We welcome conversation over the phone or face-to-face.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Course Enquiries Form */}
              <div className="col-lg-7" data-aos="fade-up" data-aos-delay="200">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    backgroundColor: '#F5EBFA',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '25px',
                    border: '3px solid #B17ACC'
                  }}>
                    <i className="bi bi-chat-dots-fill" style={{ fontSize: '1.8rem', color: '#B17ACC' }}></i>
                  </div>
                  
                  <h2 className="mb-3" style={{ 
                    color: '#1e293b', 
                    fontSize: '1.8rem',
                    fontWeight: '700',
                    letterSpacing: '-0.5px'
                  }}>
                    Course Enquiries and Admission
                  </h2>
                  <p style={{ color: '#475569', marginBottom: '2rem', fontSize: '1.05rem', lineHeight: '1.7' }}>
                    If you have an enquiry about DTK College or our courses/services, you can call 0208 555 2999 or 
                    complete the submit this form. We will get in touch as soon as possible.
                  </p>

                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <input 
                        type="text" 
                        name="name" 
                        className="form-control" 
                        placeholder="Your name" 
                        value={formData.name}
                        onChange={handleChange}
                        required
                        style={{
                          backgroundColor: '#f8fafc',
                          border: '2px solid #e2e8f0',
                          color: '#1e293b',
                          padding: '14px 18px',
                          borderRadius: '12px',
                          fontSize: '1rem'
                        }}
                      />
                    </div>

                    <div className="mb-3">
                      <input 
                        type="email" 
                        name="email" 
                        className="form-control" 
                        placeholder="Your email" 
                        value={formData.email}
                        onChange={handleChange}
                        required
                        style={{
                          backgroundColor: '#f8fafc',
                          border: '2px solid #e2e8f0',
                          color: '#1e293b',
                          padding: '14px 18px',
                          borderRadius: '12px',
                          fontSize: '1rem'
                        }}
                      />
                    </div>

                    <div className="mb-3">
                      <input 
                        type="tel" 
                        name="phone" 
                        className="form-control" 
                        placeholder="Phone" 
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        style={{
                          backgroundColor: '#f8fafc',
                          border: '2px solid #e2e8f0',
                          color: '#1e293b',
                          padding: '14px 18px',
                          borderRadius: '12px',
                          fontSize: '1rem'
                        }}
                      />
                    </div>

                    <div className="mb-3">
                      <input 
                        type="text" 
                        name="subject" 
                        className="form-control" 
                        placeholder="Subject" 
                        value={formData.subject}
                        onChange={handleChange}
                        required
                        style={{
                          backgroundColor: '#f8fafc',
                          border: '2px solid #e2e8f0',
                          color: '#1e293b',
                          padding: '14px 18px',
                          borderRadius: '12px',
                          fontSize: '1rem'
                        }}
                      />
                    </div>

                    <div className="mb-3">
                      <textarea 
                        name="message" 
                        className="form-control" 
                        rows="5" 
                        placeholder="Your message (optional)" 
                        value={formData.message}
                        onChange={handleChange}
                        style={{
                          backgroundColor: '#f8fafc',
                          border: '2px solid #e2e8f0',
                          color: '#1e293b',
                          padding: '14px 18px',
                          borderRadius: '12px',
                          fontSize: '1rem',
                          resize: 'vertical'
                        }}
                      ></textarea>
                    </div>

                    <div className="form-check mb-4">
                      <input 
                        className="form-check-input" 
                        type="checkbox" 
                        id="dataProtection"
                        required
                        style={{
                          width: '20px',
                          height: '20px',
                          border: '2px solid #e2e8f0',
                          borderRadius: '5px',
                          cursor: 'pointer'
                        }}
                      />
                      <label className="form-check-label" htmlFor="dataProtection" style={{ 
                        color: '#475569', 
                        fontSize: '0.95rem',
                        marginLeft: '8px'
                      }}>
                        I'd like to receive more information
                      </label>
                    </div>

                    {/* Status Message */}
                    {submitStatus.message && (
                      <div 
                        className="mb-4 p-3" 
                        style={{
                          backgroundColor: submitStatus.type === 'success' ? '#F5EBFA' : '#fef2f2',
                          border: `2px solid ${submitStatus.type === 'success' ? '#B17ACC' : '#ef4444'}`,
                          borderRadius: '12px',
                          color: submitStatus.type === 'success' ? '#475569' : '#991b1b',
                          fontSize: '0.95rem'
                        }}
                      >
                        <i className={`bi ${submitStatus.type === 'success' ? 'bi-check-circle-fill' : 'bi-exclamation-circle-fill'} me-2`}></i>
                        {submitStatus.message}
                      </div>
                    )}

                    <button 
                      type="submit" 
                      className="btn"
                      disabled={isSubmitting}
                      style={{
                        background: isSubmitting ? '#94a3b8' : 'linear-gradient(135deg, #B17ACC 0%, #7B3F9E 100%)',
                        border: 'none',
                        color: 'white',
                        padding: '16px 50px',
                        fontSize: '1.1rem',
                        fontWeight: '600',
                        borderRadius: '12px',
                        boxShadow: '0 4px 15px rgba(123, 63, 158, 0.3)',
                        transition: 'all 0.3s ease',
                        cursor: isSubmitting ? 'not-allowed' : 'pointer'
                      }}
                      onMouseOver={(e) => {
                        if (!isSubmitting) {
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = '0 6px 20px rgba(123, 63, 158, 0.4)';
                        }
                      }}
                      onMouseOut={(e) => {
                        if (!isSubmitting) {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 4px 15px rgba(123, 63, 158, 0.3)';
                        }
                      }}
                    >
                      {isSubmitting ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Sending...
                        </>
                      ) : (
                        <>
                          Submit <i className="bi bi-arrow-right ms-2"></i>
                        </>
                      )}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default ContactUs;